import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { ErrorResponse } from 'interfaces/global.types';
import userService from 'services/user';
import { roleList } from 'configs/data';

export const useUserDetails = (
  id: number,
  setValue?: Function,
  setActive?: (e: string) => void
) => {
  return useQuery(['user_getID', id], () => userService.getID(id), {
    onSuccess: (res: any) => {
      const role = roleList.results.find((value: any) => value.id === res.user_type);
      setValue?.('username', res.username);
      setValue?.('user_type', {
        label: role?.label,
        id: role?.id,
      });
      setValue?.('email', res.email);
      setActive?.(res.status);
    },
    onError: (error: ErrorResponse) => toast.error(error?.data?.detail),
    enabled: Boolean(id),
  });
};
